import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .InvestRatingPage__description {
    margin-bottom: rem(30px);
  }
`;

export { staticStyles };
